module.exports = __webpack_public_path__ + "img/electron.4ca4dabd.svg";